import React from 'react';
import IconButton from 'material-ui/IconButton';
import immutable from 'immutable';
import classnames from 'classnames';

import {componentHoc} from 'utils/mixin/componentHoc';

import 'styles/search/IconButtonGroup.styl';
import 'styles/StringSearchField.styl';
import 'styles/ComboboxSearchField.styl';

/**
 * A `IconButtonGroup` renders multiple material-ui rasied buttons in a
 * horizontal line and at most only 1 button is selectable at any given time.
 * Also, selecting 1 button deselects the rest of the buttons, i.e., the buttons
 * are mutually exclusive
 */
@componentHoc
class IconButtonGroup extends React.Component {
  onTouchTapIconButton(e) {
    const key = e.currentTarget.dataset.opt;
    this.props.onTouchTapIconButton(key);
  }

  render() {
    const widthInlinePadding = this.props.widthInlinePadding ? this.props.widthInlinePadding : 1;
    const highlightMode = this.props.highlightMode ? this.props.highlightMode : 'background';
    return (
      <div className="icon-button-group-parent">
        {this.props.buttonOptions.map((opt, idx) => {
          let optClassname = opt.className;
          if (opt.key === this.props.selectedOptionKey && highlightMode === 'foreground') {
            optClassname = classnames(optClassname, `${optClassname}-highlighted`, 'highlighted');
          }
          const iconButtonGroupDivStyle = this.props.getIconButtonInGroupDivStyle(
            opt,
            idx,
            widthInlinePadding,
            highlightMode
          );
          return (
            <div key={opt.key} className="icon-button-group" style={iconButtonGroupDivStyle}>
              <div className="icon-button-group-button">
                <IconButton
                  data-opt={opt.key}
                  className={optClassname}
                  style={buttonStyleInGroup}
                  onClick={this.onTouchTapIconButton.bind(this)}>
                  {!!opt.icon && opt.icon}
                </IconButton>
              </div>
            </div>
          );
        })}
        <br />
        {this.props.buttonLabels
          ? this.props.buttonLabels.map((label, idx) => {
              let labelClassname = 'icon-button-group-label';
              labelClassname = classnames(labelClassname, {
                'icon-button-group-label-hidden':
                  label.key !== this.props.selectedOptionKey && !this.props.showAllLabels,
                // new style for labels
                'icon-button-group-label-unselected':
                  label.key !== this.props.selectedOptionKey && this.props.showAllLabels,
              });
              let labelStyle = this.props.getIconButtonInGroupLabelStyle(
                label,
                idx,
                widthInlinePadding,
                highlightMode
              );
              if (this.props.iconButtonLabelStyle) {
                labelStyle = immutable
                  .Map(labelStyle)
                  .merge(this.props.iconButtonLabelStyle)
                  .toObject();
              }
              return (
                <div key={label.key} className={labelClassname} style={labelStyle}>
                  <div
                    className="icon-button-group-label-div"
                    style={{fontSize: this.props.fontSize}}>
                    {label.name}
                  </div>
                </div>
              );
            })
          : null}
      </div>
    );
  }
}

const buttonStyleInGroup = {
  background: 'white',
  height: '100%',
  width: '100%',
  border: 'none',
};

export default IconButtonGroup;
